import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Checkbox, Divider, ListItemText, Menu, MenuItem } from '@mui/material';
import IcoButtonSimple from '@/components/UI/IcoButton/IcoButton';
import SimpleButton from '@/components/UI/SimpleButton/SimpleButton';
import { ColumnConfig } from '@/types/TableListEditable';
import styles from './ColumnVisibilityMenu.module.scss';

interface ColumnVisibilityMenuProps {
  columns: ColumnConfig[];
  hiddenColumns: Set<string>;
  excludedColumnName?: string;
  tooltipText: string;
  onToggleColumn: (columnName: string) => void;
  onResetColumnsSettings?: () => void;
}

const ColumnVisibilityMenu: React.FC<ColumnVisibilityMenuProps> = ({
  columns,
  hiddenColumns,
  excludedColumnName,
  tooltipText,
  onToggleColumn,
  onResetColumnsSettings,
}) => {
  const { t } = useTranslation();
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

  const handleResetColumnsSettings = () => {
    onResetColumnsSettings?.();
    setAnchorEl(null);
  };

  return (
    <div className={styles.ColumnVisibilityToolbar}>
      <IcoButtonSimple
        id="btn-column-visibility"
        icon="icon-layout"
        tooltipText={tooltipText}
        handleClick={(event) => setAnchorEl(event.currentTarget as unknown as HTMLElement)}
      />
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={() => setAnchorEl(null)}
      >
        {columns
          .filter((column) => column.name !== excludedColumnName)
          .map((column) => (
            <MenuItem key={column.name} onClick={() => onToggleColumn(column.name)} dense>
              <Checkbox checked={!hiddenColumns.has(column.name)} size="small" />
              <ListItemText primary={column.title} />
            </MenuItem>
          ))}
        {onResetColumnsSettings && (
          <>
            <Divider />
            <div className={styles.ResetColumnsSettingsContainer}>
              <SimpleButton
                id="btn-reset-columns-settings"
                color="primary"
                buttonText={t('campaignRequests.resetColumnSettings')}
                handleClick={handleResetColumnsSettings}
                buttonClassName={styles.ResetColumnsSettingsButton}
              />
            </div>
          </>
        )}
      </Menu>
    </div>
  );
};

export default ColumnVisibilityMenu;
